var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-100" }, [
    _c(
      "div",
      {
        staticClass:
          "d-flex align-items-center justify-content-center h-100 flex-column"
      },
      [
        _c("div", { staticClass: "position-relative search-input mb-24" }, [
          _c("span", {
            staticClass: "search",
            domProps: { innerHTML: _vm._s(_vm.svg("search")) }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchText,
                expression: "searchText"
              }
            ],
            attrs: {
              type: "text",
              placeholder: "Zoek jouw volgende activiteit..."
            },
            domProps: { value: _vm.searchText },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.submitSearch($event)
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.searchText = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "arrow-right",
            domProps: { innerHTML: _vm._s(_vm.svg("long-arrow-right")) },
            on: { click: _vm.submitSearch }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tag-row tag-row-lg justify-content-center mb-8" },
          _vm._l(_vm.typeCategories, function(category) {
            return _c(
              "div",
              { key: category.id, staticClass: "tag-col mb-16 mb-md-8" },
              [
                _c("a", {
                  staticClass: "tag tag-white tag-sm",
                  attrs: {
                    href: _vm.route("nl.activities", {
                      categories: category.slug
                    })
                  },
                  domProps: { innerHTML: _vm._s(category.name) }
                })
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "text-white filter-button",
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.show_filters = !_vm.show_filters
              }
            }
          },
          [
            _c("span", {
              staticClass: "filter-icon mr-8",
              domProps: { innerHTML: _vm._s(_vm.svg("filter")) }
            }),
            _c("small", [_vm._v("Filter")])
          ]
        ),
        _vm._v(" "),
        _c("filter-menu", {
          attrs: {
            "grouped-categories": this.groupedCategories,
            show: _vm.show_filters,
            cta: "Ga verder",
            "cta-link": _vm.ctaLink
          },
          on: {
            close: function($event) {
              _vm.show_filters = false
            }
          },
          model: {
            value: _vm.selectedCategories,
            callback: function($$v) {
              _vm.selectedCategories = $$v
            },
            expression: "selectedCategories"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }